import { DeleteRoomOverlayModel } from "../DeleteRoomOverlay"
import { DeleteRoomOverlayViewModel } from "../DeleteRoomOverlayView"

export const useDeleteRoomOverlayViewModel = ({
  payload,
  ...rest
}: DeleteRoomOverlayModel): DeleteRoomOverlayViewModel => {
  return {
    isMulti: payload.roomsToDelete.length > 1,
    ...rest
  }
}
